import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/user-invites/get/by-id.ts
var by_id_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var ResponseSchema = z.object({
	email: z.string(),
	uuid: z.string()
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { by_id_exports };

//# sourceMappingURL=by-id.js.map